const userOrder = {
  header: {
    toolbar: {
      all: 'Все',
      keyword: 'Ключевое слово',
      direct: 'Прямой',
      cpi: 'CPI',
      hqr: 'HQR',
    }

  },
  table: {
    adminUserCampaigns: 'Кампании пользователя-администратора',
    showing: 'показывается',
    campaignsOf: 'кампании из',
    found: 'найдено',
    campaignFrom: 'компания из',
    nothingFoundBySearch: 'Ничего не найдено с помощью поиска',
    noCampaignsFound: 'Кампаний не найден',
    submit: 'Отправить',
    changeVendor: 'Изменить поставщика'
  },
  messages: {
    messageSent: 'Сообщение успешно отправлено'
  },
  modal: {
    sendMessage: 'Отправить сообщение',
    recordsNotFound: 'Записи не найдены',
    statusChangeHistory: 'изменение статуса history',
    changeProgress: 'Ход обновления',
  },
  actionsDropdown: {
    updateProgress: 'Ход обновления',
  }
};

export default userOrder;
